module.exports = __webpack_public_path__ + "img/collection-diamondJewelryBracelets.315ebe3.jpg";